import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import bannerController from '../bannerController/index'
import sysHome from '../sysHome/index'
import labelController from '../labelController/index'
import menuManagement from '../menuManagement'
import subjectController from '../subjectController/index'
import createSubject from "../subjectController/createSubject"
import createVocation from "../subjectController/createVocation"
import createEnergize from "../subjectController/createEnergize"
import userController from '../userController/index'
import EightAppletUser from '../userController/EightAppletUser'
import RoleManagement from '../roleManagement'
import advertController from '../advertController/index'
import activityManage from '../activityManage/index'
import freePunch from "../freePunch/index"
import userfeedback from '../userfeedback/index'
import inductionManage from '../inductionManage/index'
import inductionManageDetails from '../inductionManage/details'
import aboutController from '../aboutController/index'
import HeaderTop from '../../commponents/header/index'
import SiderLeft from '../../commponents/leftMenu/index'
import commentController from '../commentController/index'
import shareTemplateController from '../shareTemplateController/index'
import admin from '../admin/index'
import SeekLessons from '../seekLessons/index'
import Stage from '../stage/index'
import Course from '../course/index'
import AddCourse from '../addCourse/index'
import ExcellentCourse from '../excellentCourse/index'
import AddExcellentCourse from '../excellentCourse/addExcellentCourse/index'
import Catalogue from '../catalogue/index'
import datumSquare from "../datumSquare/index"
import newDatum from "../datumSquare/newDatum"
import liveController from '../liveController/index'
import LiveDeatil from '../liveController/liveDeatil'
import bootVedio from "../bootCampet/bootVedio"
import QuestionBank from '../questionBank/index'
import Knowledge from "../Knowledge/index"
import Testquestions from "../Testquestions/index"
import Interview from "../TypeTopic/interview"
import TypeTopic from "../TypeTopic/index"
import CommentModer from "../commentController/CommentModer"
import bootCampet from "../bootCampet/index"
import newSurface from "../subjectController/newSurface"
import datum from "../datum/index"
import ZipDetail from "../datum/detail"
import AddOrUpdateForm from "../datum/addOrUpdateForm"
import Paycourse from "../paycourse/index"
import PayDetail from "../paycourse/detail"
// import activityxetback from "../activityxetback/index"
// import DataList from "../dataList/index"
import ChannelIndex from '../channelManagement/channelIndex'
import activityController from "../activityController/index"
import systemSet from "../systemSet/index"
import setPiclink from "../setPiclink/index"
import fissionstaManagement from '../fissionstaManagement'
import schoolAmbassador from '../schoolAmbassador'
import IntegralDetails from '../IntegralDetails'
import Statistics from '../statistics/index'
import WeightActivation from '../weightActivation/index'
import ChannelManagement from '../channelManagement/index'
import itStudy from '../itStudy/index'
import wxChannelsDetail from '../statistics/wxChannelsDetail'
import logout from '../logout/index'
import miniProgram from '../miniProgram/index'
import { Layout, Card } from 'antd';
import './home.less'
import { getMenu } from "../../utils/util";
import instance from '../../service'
import mianJing from '../mianJing/index'
const { Header, Sider, Content } = Layout;

class Home extends Component {
	constructor(props) {
		console.log("props",props)
		super(props)
		this.state = {
			pathname: "",
			menuListRole: [],
			buttonListdata: [],
			meauList: [
				{
					path: '/labelController',
					name: '标签管理',
					component: labelController
				},
				{
					path: '/bannerController',
					name: '轮播图管理',
					component: bannerController
				},
				{
					path: '/sysHome',
					name: '系统首页',
					component: sysHome
				},
				{
					path: '/subjectController',
					name: '学科管理',
					component: subjectController,
				},
				{
					path: '/createSubject',
					name: '新建学科',
					component: createSubject,
				},
				{
					path: '/createVocation',
					name: '新建课程',
					component: createVocation,
				},
				{
					path: '/createEnergize',
					name: '新建赋能课',
					component: createEnergize,
				},
				{
					path: '/Stage',
					name: '阶段',
					component: Stage,
				},
				{
					path: '/Course',
					name: '课程列表',
					component: Course,
				},
				{
					path: '/AddCourse',
					name: '添加课程',
					component: AddCourse,
				},
				{
					path: '/Catalogue',
					name: '目录',
					component: Catalogue,
				},
        {
					path: '/ExcellentCourse',
					name: '精品课',
					component: ExcellentCourse,
				},
        {
					path: '/AddExcellentCourse',
					name: '添加精品课',
					component: AddExcellentCourse,
				},
				{
					path: '/datumSquare',
					name: '资料广场',
					component: datumSquare,
				},
				{
					path: '/newDatum',
					name: '新建资料',
					component: newDatum
				},
				{
					path: '/userController',
					name: '用户管理',
					component: userController
				},
				{
					path: '/EightAppletUser',
					name: '学科矩阵用户管理',
					component: EightAppletUser
				},
				{
					path: '/fissionstaManagement',
					name: '裂变分享',
					component: fissionstaManagement
				},
				{
					path: '/sys/*',
					name: '角色管理',
					component: RoleManagement
				},
				{
					path: '/freePunch',
					name: '免费打卡海报',
					component: freePunch
				},
				{
					path: '/advertController',
					name: '广告管理',
					component: advertController
				},
				{
					path: '/newSurface',
					name: '新建面经',
					component: newSurface
				},
				{
					path: '/activityManage',
					name: '活动管理',
					component: activityManage
				},
				{
					path: '/userfeedback',
					name: '用户反馈',
					component: userfeedback
				},
				{
					path: '/inductionManage',
					name: '入门测管理',
					component: inductionManage
				},
				{
					path: '/inductionManageDetails',
					name: '入门测详情',
					component: inductionManageDetails
				},
				{
					path: '/liveController',
					name: '直播管理',
					component: liveController
				},
				{
					path: '/LiveDeatil',
					name: '直播详情',
					component: LiveDeatil
				},
				{
					path: '/QuestionBank',
					name: '题库管理',
					component: QuestionBank
				},
				{
					path: '/konwledge',
					name: '题库管理',
					component: Knowledge
				},
				{
					path: '/Test',
					name: '试题',
					component: Testquestions
				},
				{
					path: '/type',
					name: '试题',
					component: TypeTopic
				},
				{
					path: '/interview',
					name: '试题',
					component: Interview
				},
				{
					path: '/mianJing',
					name: '面经',
					component: mianJing
				},
				{
					path: '/datum',
					name: '资料包管理',
					component: datum
				},
				{
					path: '/detail',
					name: '资料包',
					component: ZipDetail
				},
				{
					path: '/pack',
					name: '资料包',
					component: AddOrUpdateForm
				},
				{
					path: '/paycourse',
					name: '资源管理',
					component: Paycourse
				},
				{
					path: '/class',
					name: '付费课',
					component: PayDetail
				},
				{
					path: '/shareTemplateController',
					name: '海报模板管理',
					component: shareTemplateController
				},
				{
					path: '/SeekLessons',
					name: '学生求课',
					component: SeekLessons
				},
				{
					path: '/comment',
					name: '面经评论审核',
					component: CommentModer
				},
				{
					path: '/bootVedio',
					name: '视频详情',
					component: bootVedio
				},
				{
					path: '/bootCampet',
					name: '训练营管理',
					component: bootCampet
				},
				{
					path: '/commentController',
					name: '审核管理',
					component: commentController
				},
				{
					path: '/aboutController',
					name: '关于我们',
					component: aboutController
				},
				{
					path: '/schoolAmbassador',
					name: '校园大使',
					component: schoolAmbassador
				},
				{
					path: '/IntegralDetails',
					name: '积分详情',
					component: IntegralDetails
				},
				{
					path: '/admin',
					name: '账号管理',
					component: admin
				},
				{
					path: '/menuManagement',
					name: '菜单管理',
					component: menuManagement
				},
				// {
				// 	path: '/activityxetback',
				// 	name: '活动海报',
				// 	component: activityxetback
				// },
				// {
				// 	path: '/data',
				// 	name: '数据统计',
				// 	component: DataList
				// },
				{
					path: '/activityController',
					name: '投票活动',
					component: activityController
				},
				{
					path: '/systemSet',
					name: '系统设置',
					component: systemSet
				},
				{
					path: '/setPiclink',
					name: '图片链接生成',
					component: setPiclink
				},
				{
					path: '/statistics',
					name: '数据分类统计',
					component: Statistics
				},
				{
					path: '/weightActivation',
					name: '重量激活',
					component: WeightActivation
				},
				{
					path: '/channelIndex',
					name: '渠道管理',
					component: ChannelIndex
				},
				{
					path: '/channelManagement',
					name: '渠道管理',
					component: ChannelManagement
				},
				{
					path: '/itStudy',
					name: '渠道管理',
					component: itStudy
				},
				{
					path: '/wxChannelsDetail',
					name: '题库管理',
					component: wxChannelsDetail
				},
				{
					path: '/logout',
					name: '操作记录',
					component: logout
				},
        {
					path: '/miniProgram',
					name: '小程序管理',
					component: miniProgram
				},
			],
			meauItem: '/sysHome'
		}
	}
	static getDerivedStateFromProps(props, state) {
		let pathname = props.location.pathname;
		//查询保存当前页面是否有按钮
		var url = '/' + pathname.split('/').pop()
		var arr = JSON.parse(localStorage.getItem('menuList'))
		if (arr) {
			let result = getMenu(url, arr)
			if (result && result.children.length) {
				result.children.map(item => {
					var buttonList = (item.children && item.children.length) ? item.children.filter(k => k.checked) : []
				  return	localStorage.setItem('buttonList', JSON.stringify(buttonList))
				})
			}
		}
		if (pathname === '/') {
			return state.meauItem = '/sysHome'
		} else {
			return state.meauItem = pathname
		}
	}

	componentDidMount() {
		this.getUserMenu()
		if (!localStorage.getItem('token')) {
			this.props.history.replace('/login')
			return
		}
		let pathname = this.props.location.pathname;
		if (pathname === '/') {
			this.setState({
				meauItem: '/sysHome'
			})
		} else {
			this.setState({
				meauItem: pathname
			})
		}
	}
	componentWillUnmount() {
		this.setState = () => false;
	}
	getchild = v => {
		this.setState({ meauItem: v })
	}
	getRoute = () => {
		let a = this.state.meauList.filter(item => item.path === this.state.meauItem)
		if (a.length) {
			return (
				<Route path={a[0].path} component={a[0].component}></Route>
			)
		}
	}

	//获取用户菜单
	getUserMenu() {
		instance.get('/sys/home').then(res => {
			if (res.data.code === 200) {
				this.setState({
					menuListRole: res.data.data.menus
				})
				localStorage.setItem('menuList', JSON.stringify(res.data.data.menus))
			}
		})
	}
	render() {
		return (
			<div className="P-home">
				<Layout>
					<Header><HeaderTop /></Header>
					<Layout>
						<Sider><SiderLeft defaultPath={this.state.meauItem} menuListRole={this.state.menuListRole} getChildPath={this.getchild} /></Sider>
						<Content>
							<div className="container">
								<Card bordered>
									<Switch>
										{
											this.getRoute()
										}
										<Redirect to={'/sysHome'}></Redirect>
									</Switch>
								</Card>
							</div>
						</Content>
					</Layout>
				</Layout>
			</div>
		)
	}
}

export default Home